/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimCenterBookableSchedule } from './ClaimCenterBookableSchedule';
import {
    ClaimCenterBookableScheduleFromJSON,
    ClaimCenterBookableScheduleFromJSONTyped,
    ClaimCenterBookableScheduleToJSON,
} from './ClaimCenterBookableSchedule';

/**
 * 
 * @export
 * @interface ClaimCenterBookableSchedules
 */
export interface ClaimCenterBookableSchedules {
    /**
     * 
     * @type {Array<ClaimCenterBookableSchedule>}
     * @memberof ClaimCenterBookableSchedules
     */
    schedules: Array<ClaimCenterBookableSchedule>;
}

/**
 * Check if a given object implements the ClaimCenterBookableSchedules interface.
 */
export function instanceOfClaimCenterBookableSchedules(value: object): value is ClaimCenterBookableSchedules {
    if (!('schedules' in value) || value['schedules'] === undefined) return false;
    return true;
}

export function ClaimCenterBookableSchedulesFromJSON(json: any): ClaimCenterBookableSchedules {
    return ClaimCenterBookableSchedulesFromJSONTyped(json, false);
}

export function ClaimCenterBookableSchedulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCenterBookableSchedules {
    if (json == null) {
        return json;
    }
    return {
        
        'schedules': ((json['schedules'] as Array<any>).map(ClaimCenterBookableScheduleFromJSON)),
    };
}

export function ClaimCenterBookableSchedulesToJSON(value?: ClaimCenterBookableSchedules | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'schedules': ((value['schedules'] as Array<any>).map(ClaimCenterBookableScheduleToJSON)),
    };
}

